export default __webpack_public_path__ + "static/media/IMG_20190720_200726.5cce8ec4.jpg";